import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

// Selectors
const getDls = path(["domain", "ui", "dls"]);

export const selectDls = createSelector(getDls, identity);

export const selectShowPresentationMode = createSelector(
  getDls,
  prop("showPresentationMode")
);

// Initial State
const initialState = () => ({
  showPresentationMode: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
